import { Injectable } from '@angular/core';
import { BaseService, LeagueNews, LeagueNewsApi } from '@mtgame/core';
import { Observable } from 'rxjs';

export const STORE_NEWS_KEY = 'news';

@Injectable({providedIn: 'root'})
export class NewsDetailService extends BaseService {
  private newsId: number;

  get news$(): Observable<LeagueNews> {
    return this.store.get(STORE_NEWS_KEY);
  }

  constructor(
    private leagueNewsApi: LeagueNewsApi,
  ) {
    super();
  }

  async initialize(newsId: number): Promise<LeagueNews> {
    this.newsId  = newsId;
    return await this.getNews();
  }

  async getNews(): Promise<LeagueNews> {
    const news = await this.leagueNewsApi.getNewsById(this.newsId);
    this.store.save(STORE_NEWS_KEY, news);
    return news;
  }
}
